package app.nestbridge.feature.home.ui

import app.nestbridge.feature.home.screen.HomeScreen
import app.nestbridge.feature.home.screen.HomeState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class HomeUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    HomeScreen -> ui<HomeState> { state, modifier -> HomeUi(state = state, modifier = modifier) }
    else -> null
  }
}
